import { render, staticRenderFns } from "./CardHolder.vue?vue&type=template&id=e75a83b4&"
import script from "./CardHolder.vue?vue&type=script&lang=js&"
export * from "./CardHolder.vue?vue&type=script&lang=js&"
import style0 from "./CardHolder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports